import { render, staticRenderFns } from "./ednAlertSnackbar.vue?vue&type=template&id=2b588e62"
import script from "./ednAlertSnackbar.vue?vue&type=script&lang=js"
export * from "./ednAlertSnackbar.vue?vue&type=script&lang=js"
import style0 from "./ednAlertSnackbar.vue?vue&type=style&index=0&id=2b588e62&prod&lang=css"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports